import React from 'react'
import './projects.css'
import { projectData } from '../../DataFiles/ProjectData'
import ReactGA from 'react-ga';
const Projects = () => {

    const handleClick = () => {
        ReactGA.event({ 'category': 'Github ', 'action': 'open', 'label': 'label' });
    }
    const handleClick2 = () => {
        ReactGA.event({ 'category': 'live', 'action': 'open', 'label': 'label' });
    }
    return (
        <div className="projectSection overflow" id='project'>
            <h3 className="projectIntro">Recent Projects:</h3>

            <div className="projectGroup ">
                {projectData.map((p) => (
                    <div className="projectItem" style={{backgroundColor:`${p.color}` ,border:`2px solid ${p.color2}`}} key={p.id} data-aos="fade-up">
                        <div className="projectDetail">
                            <div className="projecttitle" >
                                <h4 style={{color:`${p.color2}`}}>{p.projectName}</h4>
                                <p style={{color:`${p.color2}`}}>{p.tech}</p>
                            </div>
                            <div className="projectDescription">
                                <p style={{color:`${p.color2}`}}>{p.description}</p>
                            </div>
                            <div className="projectBtn">
                                <a href={p.source} rel="noreferrer noopener" target="_blank">
                                    <button  onClick={handleClick} style={{border:`2px solid ${p.color2}`, color:`${p.color2}`}}>GitHub</button>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}

            </div>
            <div className='forMore'>
                <a href="https://github.com/nileshlad09" rel="noreferrer noopener" target="_blank">
                *Check GitHub for More Projects
                </a>
            </div>
        </div>
    )
}

export default Projects